import { useState } from "react";
import { actions } from "../store";
import {
  STAGE_LABEL,
  STAGE_ORDER,
  type JobCardModel,
  type PipelineStage,
} from "../types";
import { JobCard } from "./JobCard";

export function KanbanBoard({ jobs }: { jobs: JobCardModel[] }) {
  const [dragOver, setDragOver] = useState<PipelineStage | null>(null);

  return (
    <div className="grid min-h-0 flex-1 grid-cols-1 gap-3 md:grid-cols-3">
      {STAGE_ORDER.map((stage) => {
        const items = jobs.filter((j) => j.stage === stage);
        const active = dragOver === stage;
        return (
          <section
            key={stage}
            onDragOver={(e) => {
              e.preventDefault();
              setDragOver(stage);
            }}
            onDragLeave={() => setDragOver((s) => (s === stage ? null : s))}
            onDrop={(e) => {
              e.preventDefault();
              const id = e.dataTransfer.getData("text/plain");
              if (id) actions.moveJob(id, stage);
              setDragOver(null);
            }}
            className={`flex min-h-0 min-w-0 flex-col rounded-xl border transition-colors ${
              active
                ? "border-accent/70 bg-accent-soft/40"
                : "border-border/70 bg-ink/30"
            }`}
          >
            <header className="flex items-center justify-between px-3 py-2.5">
              <div className="flex items-center gap-2">
                <span
                  className={`h-1.5 w-1.5 rounded-full ${
                    stage === "discovered"
                      ? "bg-accent"
                      : stage === "interested"
                        ? "bg-amber"
                        : "bg-signal"
                  }`}
                />
                <h3 className="font-display text-[13px] font-medium tracking-wide text-text">
                  {STAGE_LABEL[stage]}
                </h3>
              </div>
              <span className="font-mono text-[11px] text-faint">{items.length}</span>
            </header>

            <div className="scroll-slim flex min-h-0 flex-1 flex-col gap-2.5 overflow-y-auto px-2.5 pb-3">
              {items.length === 0 ? (
                <p className="mt-6 px-2 text-center text-[11px] leading-relaxed text-faint">
                  {stage === "discovered"
                    ? "Discover a company above, or let the agent call discover_company_jobs."
                    : "Drag a card here."}
                </p>
              ) : (
                items.map((job) => <JobCard key={job.id} job={job} />)
              )}
            </div>
          </section>
        );
      })}
    </div>
  );
}
